module.exports = __webpack_public_path__ + "static/phone-4ee5f662ece7b33655f8fc28ee70140c.webp";